 
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';

type RankChangeRendererProps = {
  rank: number;
  previous_rank: number;
  change?: number | null;
};

const RankChangeRenderer = ({
  rank,
  previous_rank,
  change
}: RankChangeRendererProps) => {
  return (
    <div className="d-flex h-100 align-items-center justify-content-around">
      {change && (
        <h6
          className={classNames('mb-0', {
            'text-danger': change < 0 && previous_rank<800 && rank<800,
            'text-success': change > 0 && previous_rank<800 && rank<800
          })}
        >
          {change <= 100 && change >= -100 ? (
            previous_rank<800 && rank<800 ?
            <>
              {change < 0 ? -1 * change : change}
              {change > 0 ? (
                <FontAwesomeIcon icon="caret-up" className="ms-1" />
              ) : change < 0 ? (
                <FontAwesomeIcon icon="caret-down" className="ms-1" />
              ) : (
                ''
              )}
            </> : 0
          ) : (
            <>
              {change > 0
                ? previous_rank === 999
                  ? 'ورود'
                  : <span>+{(parseInt(String(previous_rank), 10) % 800) + 10} ورود</span>
                : rank === 999
                  ? 'خروج'
                  : <span>+{(parseInt(String(rank), 10) % 800) + 10} خروج</span>}
              {change > 0 ? (
                <FontAwesomeIcon icon="caret-right" className="ms-1" />
              ) : (
                <FontAwesomeIcon icon="caret-left" className="ms-1" />
              )}
            </>
          )}
        </h6>
      )}
    </div>
  );
};

export default RankChangeRenderer;
